/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountComplianceDto } from './accountComplianceDto';
import { Pair } from './pair';

export interface OrderComplianceDto {
  id?: number;
  clOrdId?: string;
  initiator?: string;
  account?: AccountComplianceDto;
  accountId?: number;
  jurisdiction?: string;
  pair?: Pair;
  side?: OrderComplianceDto.SideEnum;
  ordType?: OrderComplianceDto.OrdTypeEnum;
  timeInForce?: OrderComplianceDto.TimeInForceEnum;
  orderStatus?: OrderComplianceDto.OrderStatusEnum;
  quantity?: number;
  limitPrice?: number;
  filledQty?: number;
  clientExecutedPrice?: number;
  clientExecVolume?: number;
  receiveTime?: string;
  doneAt?: string;
}
export namespace OrderComplianceDto {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
  export const OrdTypeEnum = {
    Limit: 'LIMIT',
    Market: 'MARKET',
    StopLimit: 'STOP_LIMIT',
  } as const;
  export type OrdTypeEnum = (typeof OrdTypeEnum)[keyof typeof OrdTypeEnum];
  export const TimeInForceEnum = {
    Gtc: 'GTC',
    Ioc: 'IOC',
    Fok: 'FOK',
  } as const;
  export type TimeInForceEnum = (typeof TimeInForceEnum)[keyof typeof TimeInForceEnum];
  export const OrderStatusEnum = {
    Active: 'ACTIVE',
    Canceled: 'CANCELED',
    Filled: 'FILLED',
    PartiallyFilled: 'PARTIALLY_FILLED',
    PartiallyFilledCanceled: 'PARTIALLY_FILLED_CANCELED',
    Rejected: 'REJECTED',
    WaitingTrigger: 'WAITING_TRIGGER',
  } as const;
  export type OrderStatusEnum = (typeof OrderStatusEnum)[keyof typeof OrderStatusEnum];
}
